// Phase 5 — Notification module routes.
//
// Spec: Epic FE-US-INT-01 §6 Phase 5. The route is wired into `src/router.tsx`
// in a final user-controlled step (per the epic boundary). The route slot
// declared here MUST appear under the authenticated `<CrmShell />` element
// because it depends on Phase-0 RequireAuth gating.
//
// Path: `/accounts/:accountId/dispatches`.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const DispatchTrailPage = lazy(() =>
  import('./pages/DispatchTrailPage').then((m) => ({ default: m.DispatchTrailPage })),
);

export const notificationRoutes: RouteObject[] = [
  { path: '/accounts/:accountId/dispatches', element: <DispatchTrailPage /> },
];
